/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlockValidationTypeFields.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Validation Field Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, September 25, 2018 - 02:22:05 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/25/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlockValidationTypeFieldList = Loadable({
    loader: () => import('../containers/BlockValidationTypeFields/BlockValidationTypeFieldListContainer'),
    loading: Loading,
});

export const BlockValidationTypeFieldEdit = Loadable({
    loader: () => import('../containers/BlockValidationTypeFields/BlockValidationTypeFieldEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlockValidationTypeFields.js